// @flow
import React from 'react';
import SearchForm from '@homeaway/react-search-form';
import Experiment from '@homeaway/react-experiment';
import {SameDayAvailability} from '../DayAvailability/createDayAvailability';
import {HA_TRAVELER_SAME_DAY_BOOKINGS} from '../../abacus/experiments';
import './SearchFormWrapper.less';

export const SearchFormWrapper = () => {
    const searchFormProps = (logExperiment) => ({
        formOptions: {
            autoProgress: false,
            layout: 'standard',
            align: 'left',
            showSubmitButton: false
        },
        datesEvents: {
            onOpen: logExperiment()
        },
        guestsOptions: {
            actionLocation: 'search'
        }
    });

    return (
        <Experiment name={HA_TRAVELER_SAME_DAY_BOOKINGS} deferLogging>
            {({On, Off, logExperiment}) => {
                return (
                    <div
                        className="SearchFormWrapper"
                        data-wdio="SearchFormWrapper"
                    >
                        <On>
                            <SearchForm
                                {...searchFormProps(logExperiment)}
                                datesOptions={{
                                    dayTemplateComponent: SameDayAvailability
                                }}
                            />
                        </On>
                        <Off>
                            <SearchForm {...searchFormProps(logExperiment)} />
                        </Off>
                    </div>
                );
            }}
        </Experiment>
    );
};

export default SearchFormWrapper;
